import { Routes } from '@angular/router'
import { isAnonymous, isAuthenticated } from './shared/auth/auth.guard'
import { MainLayoutComponent } from './shared/layouts/main-layout.component'
import { SimpleLayoutComponent } from './shared/layouts/simple-layout.component'
import { offerExistsGuard, offerResolver } from './shared/offer-exists.guard'
import { unsavedChangesGuard } from './shared/unsaved-changes.guard'

export const routes: Routes = [
  {
    path: 'login',
    component: SimpleLayoutComponent,
    canActivate: [isAnonymous],
    loadChildren: () => import('./login/login.routes').then((m) => m.routes),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isAuthenticated],
    children: [
      {
        path: '',
        loadComponent: () => import('./contracts/contracts.component').then((m) => m.ContractsComponent),
      },
      {
        path: ':contractNumber',
        canActivate: [offerExistsGuard],
        resolve: { offer: offerResolver },
        loadComponent: () => import('./battery/battery-menu.component').then((m) => m.BatteryMenuComponent),
        children: [
          { path: '', redirectTo: 'contract', pathMatch: 'full' },
          {
            path: 'contract',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./steps/contract-data-step/contract-data-step.component').then(
                (m) => m.ContractDataStepComponent
              ),
          },
          {
            path: 'counterparty',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./steps/counterparty-data-step/counterparty-data-step.component').then(
                (m) => m.CounterpartyDataStepComponent
              ),
          },
          {
            path: 'battery-asset',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./steps/battery-asset-record-step/battery-asset-record-step.component').then(
                (m) => m.BatteryAssetRecordStepComponent
              ),
          },
          {
            path: 'fee',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import('./steps/fee-data-step/fee-data-step.component').then((m) => m.FeeDataStepComponent),
          },
        ],
      },
    ],
  },
]
